import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import ProfileDesktop from '../components/faraaz/ProfileDesktop'
import ProfileMobile from '../components/faraaz/ProfileMobile'
import Riya from '../assets/images/Riya.jpg'

const Rashmi = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
                <meta charSet="utf-8" />
                <title> Rashmi - 800 Homes</title>
            </Helmet>

            <section id="website-responsive" className="d-none d-md-block">
                <ProfileDesktop
                    Image={Riya}
                    Title="Rashmi"
                    Designation="Property Consultant"
                    PhoneNumberLink="+971543127810"
                    PhoneNumber="+971 54 312 7810"
                    WhatsappLink="971543127810"
                    Whatsapp="+971 54 312 7810"
                    Email="Rashmi@800homes.ae"
                />
            </section>

            <section id="website-responsive" className="d-block d-md-none">
                <ProfileMobile
                    Image={Riya}
                    Title="Rashmi"
                    Designation="Property Consultant"
                    PhoneNumberLink="+971543127810"
                    PhoneNumber="+971 54 312 7810"
                    WhatsappLink="971543127810"
                    Whatsapp="+971 54 312 7810"
                    Email="Rashmi@800homes.ae"
                />
            </section>
        </>
    )
}

export default Rashmi
